export type FilterOption = {
  value: string;
  label: string;
};

export const INDUSTRY_OPTIONS: FilterOption[] = [
  { value: 'automobiles', label: 'Automobiles' },
  { value: 'banks', label: 'Banks' },
  { value: 'capital_goods', label: 'Capital Goods' },
  { value: 'commercial_services', label: 'Commercial Services' },
  { value: 'consumer_durables', label: 'Consumer Durables' },
  { value: 'diversified_consumer_services', label: 'Consumer Services' },
  { value: 'diversified_financials', label: 'Financials' },
  { value: 'energy', label: 'Energy' },
  { value: 'food_beverages_tobacco', label: 'Food, Beverages & Tobacco' },
  { value: 'food_staples', label: 'Food Staples' },
  { value: 'health_care_equipment', label: 'Health Care Equipment' },
  { value: 'hotels_restaurants', label: 'Hotels & Restaurants' },
  { value: 'household_personal_products', label: 'Household & Personal Products' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'materials', label: 'Materials' },
  { value: 'media_and_entertainment', label: 'Media & Entertainment' },
  { value: 'pharmaceuticals_biotech', label: 'Pharmaceuticals & Biotech' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'retailing', label: 'Retailing' },
  { value: 'semiconductors', label: 'Semiconductors' },
  { value: 'software_and_services', label: 'Software & Services' },
  { value: 'technology_hardware_equipment', label: 'Technology Hardware' },
  { value: 'telecommunication_services', label: 'Telecommunication Services' },
  { value: 'transportation', label: 'Transportation' },
  { value: 'utilities', label: 'Utilities' },
];

export const REGION_COUNTRIES: Record<string, string[]> = {
  'North America': [
    'United States', 'Canada', 'Mexico', 'Antigua and Barbuda', 'Bahamas',
    'Bermuda', 'British Virgin Islands', 'Cayman Islands', 'Costa Rica',
    'Dominican Republic', 'Panama', 'Puerto Rico',
  ],
  'South America': ['Argentina', 'Brazil', 'Chile', 'Colombia', 'Peru', 'Uruguay'],
  Europe: [
    'United Kingdom', 'France', 'Germany', 'Austria', 'Belgium', 'Cyprus',
    'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'Greece', 'Hungary',
    'Iceland', 'Ireland', 'Isle of Man', 'Italy', 'Jersey', 'Latvia',
    'Luxembourg', 'Monaco', 'Netherlands', 'Norway', 'Poland', 'Portugal',
    'Russia', 'Spain', 'Sweden', 'Switzerland',
  ],
  Asia: [
    'China', 'India', 'Hong Kong', 'Indonesia', 'Israel', 'Japan', 'Jordan',
    'Kazakhstan', 'Kuwait', 'Macau', 'Malaysia', 'Mongolia', 'Pakistan',
    'Philippines', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Korea',
    'Taiwan', 'Thailand', 'Turkey', 'United Arab Emirates', 'Vietnam',
  ],
  Africa: ['Egypt', 'Namibia', 'Nigeria', 'South Africa', 'Tanzania'],
  Oceania: ['Australia', 'New Zealand', 'Marshall Islands'],
};

export const COUNTRIES = Object.values(REGION_COUNTRIES).reduce(
  (allCountries, countries) => allCountries.concat(countries),
  [] as string[]
);

export const labelForIndustry = (value: string): string =>
  INDUSTRY_OPTIONS.find(option => option.value === value)?.label || value;
